module.exports = {
    SLIDER: 'SLDR',
    CARD: 'CRD'
  };